export default __webpack_public_path__ + "static/media/news4.aae13191.png";